import { render, staticRenderFns } from "./FacilityFormModal.vue?vue&type=template&id=2412e520&scoped=true&"
import script from "./FacilityFormModal.vue?vue&type=script&lang=js&"
export * from "./FacilityFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412e520",
  null
  
)

export default component.exports